import React, { useEffect, useState } from 'react';
import { useSolplace } from '../context/SolplaceContext';
import './Notification.css';

const Notification = () => {
  const { notification } = useSolplace();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (notification) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  if (!notification) return null;

  return (
    <div className={`notification ${notification.type} ${show ? 'show' : ''}`}>
      {notification.message}
    </div>
  );
};

export default Notification;
